import PropTypes from 'prop-types';
import React from 'react';
import ScrollableContainer from '../components/ScrollableContainer';

const blockScreenClass = isScreenBlocked => `${isScreenBlocked ? ' block-screen' : ''}`;

const greyOutScreenClass = isGreyedOut => `${isGreyedOut ? ' disabled-measure' : ''}`;

const SplitLayout = props => (
    <div
        className={
            `assessment-window ${props.class}` +
            `${blockScreenClass(props.isScreenBlocked)}` +
            `${greyOutScreenClass(props.isGreyedOut)}`
        }
    >
        <div className="measure-upper">{!props.isFetching && props.upperElement}</div>
        {props.enableScroll ? (
            <ScrollableContainer className="measure-lower" resetScrollKey={props.questionIndex}>
                {!props.isFetching && props.lowerElement}
            </ScrollableContainer>
        ) : (
            <div className="measure-lower">{!props.isFetching && props.lowerElement}</div>
        )}
        {props.children}
    </div>
);

SplitLayout.propTypes = {
    children: PropTypes.node,
    upperElement: PropTypes.node,
    lowerElement: PropTypes.node,
    isFetching: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
    isGreyedOut: PropTypes.bool,
    enableScroll: PropTypes.bool,
    class: PropTypes.string,
    questionIndex: PropTypes.number,
};

SplitLayout.defaultProps = {
    children: undefined,
    upperElement: undefined,
    lowerElement: undefined,
    isFetching: false,
    isScreenBlocked: false,
    isGreyedOut: false,
    enableScroll: false,
    class: '',
    questionIndex: undefined,
};

export default SplitLayout;
